export default __webpack_public_path__ + "static/media/10_1.c2f6bcd3.jpg";